import React, { useEffect, useState, useCallback } from 'react';
import { adminApi } from '../../lib/adminApi';
import { Compass, Users, CalendarDays, Trophy } from 'lucide-react';

const Bars = ({ title, rows, color, testId }) => {
  const max = Math.max(1, ...rows.map((r) => r.count));
  return (
    <div className="bg-slate-900/50 rounded-2xl p-5" data-testid={testId}>
      <h3 className="font-semibold mb-4">{title}</h3>
      {rows.length === 0 && <p className="text-sm text-slate-500">Sin datos todavía.</p>}
      <div className="space-y-3">
        {rows.map((r) => (
          <div key={r.key}>
            <div className="flex justify-between text-sm mb-1"><span>{r.label || r.key}</span><span className="text-slate-400"><span className="text-white font-semibold">{r.count}</span></span></div>
            <div className="h-2 rounded-full bg-white/10 overflow-hidden"><div className={`h-full rounded-full bg-gradient-to-r ${color}`} style={{ width: `${(r.count / max) * 100}%` }}></div></div>
          </div>
        ))}
      </div>
    </div>
  );
};

const Kpi = ({ icon: Icon, value, label, testId }) => (
  <div className="bg-slate-900/50 rounded-2xl p-4 flex items-center gap-3" data-testid={testId}>
    <div className="h-10 w-10 rounded-xl bg-blue-600/30 flex items-center justify-center"><Icon className="h-5 w-5 text-blue-300" /></div>
    <div><p className="text-2xl font-bold leading-none">{value ?? '—'}</p><p className="text-xs text-slate-400 mt-1">{label}</p></div>
  </div>
);

export const ComparadorStats = ({ onAuthError }) => {
  const [stats, setStats] = useState(null);
  const load = useCallback(() => adminApi.get('/comparador/stats').then(({ data }) => setStats(data)).catch(onAuthError), [onAuthError]);
  useEffect(() => { load(); }, [load]);

  return (
    <section className="bg-white/5 border border-white/10 rounded-3xl p-6 space-y-6" data-testid="admin-comparador-stats">
      <div>
        <h2 className="text-lg font-semibold">Estadísticas del comparador</h2>
        <p className="text-slate-400 text-sm">Qué eligen los visitantes y a quién se les recomendó</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
        <Kpi icon={Compass} value={stats?.total} label="Usos totales" testId="comparador-kpi-total" />
        <Kpi icon={CalendarDays} value={stats?.last_7_days} label="Últimos 7 días" testId="comparador-kpi-7d" />
        <Kpi icon={Users} value={stats?.leads} label="Leads captados" testId="comparador-kpi-leads" />
        <Kpi icon={Trophy} value={stats?.recomendados?.[0]?.key?.split(' ')[0]} label="Más recomendado" testId="comparador-kpi-top" />
      </div>
      {stats && (
        <div className="grid lg:grid-cols-3 gap-4">
          <Bars title="Destinos más elegidos" rows={stats.destinos} color="from-blue-500 to-cyan-400" testId="comparador-chart-destinos" />
          <Bars title="Prioridades más marcadas" rows={stats.prioridades} color="from-emerald-500 to-teal-400" testId="comparador-chart-prioridades" />
          <Bars title="Aliado recomendado" rows={stats.recomendados} color="from-amber-500 to-orange-400" testId="comparador-chart-recomendados" />
        </div>
      )}
      {stats?.avg_edad != null && <p className="text-xs text-slate-500">Promedio: {stats.avg_edad} años · {stats.avg_dias} días de viaje</p>}
    </section>
  );
};

export default ComparadorStats;
